import * as React from "react";
const NewViewLoaderContext = React.createContext(() => {
});
export default NewViewLoaderContext;
